<template>
    <div class="about-page">
        <div class="background-overlay"></div>
      <HeaderComponent />
      <main>
        <h1>WIP</h1>
        <p>WIP</p>
      </main>
      <FooterComponent />
    </div>
  </template>
  
  <script>
  import HeaderComponent from '@/components/Header.vue';
  import FooterComponent from '@/components/Footer.vue';
  
  export default {
    name: 'AboutPage',
    components: {
      HeaderComponent,
      FooterComponent
    }
  };
  </script>
  

  
  
  <style scoped>
  .about-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  text-align: center;
  color: white;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
  position: relative;
  z-index: 1;
  }
  

  nav ul {
    list-style-type: none;
    display: flex;
    justify-content: center;
  }
  
  nav ul li {
    margin: 0 15px;
  }
  
  nav ul li a {
    color: white;
    text-decoration: none;
  }
  
  main {
  flex: 1; /* This allows main to take up remaining space */
  margin-top: 50px;
}

.background-overlay {
  position: fixed; /* Fixe l'arrière-plan */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/backgrounds/Background1.png); /* Votre image de fond */
  background-size: cover; /* Couvre toute la fenêtre */
  background-position: center center;
  background-repeat: no-repeat;
  z-index: -1; /* Place le fond derrière tout le contenu */
}
  
  h1 {
    font-size: 2rem;
  }
  </style>
  